module.exports = __webpack_public_path__ + "static/media/pet-policy.7c1d829f.svg";